// skeleton\app\src\app\auth\auth.service.ts

import { Injectable } from '@angular/core';
import { Constants } from '../shared/constants';
import { BaseHttpService } from '../shared/services/basehttp.service';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { StorageService } from '../shared/services/token-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constant: Constants = new Constants();

  constructor(
    private baseHttpService: BaseHttpService,
    private router: Router,
    private http: HttpClient,
    private storage: StorageService
  ) {}

  getToken(): string {
    return this.storage.get('token');
  }

  async isTokenValid(): Promise<boolean> {
    const token = this.getToken();
    if (!token) return false;

    try {
      const split = JSON.parse(atob(token.split('.')[1]));
      const expiry = split.exp;
      const now = new Date().getTime() / 1000;

      if (expiry > now) {
        console.log('[AuthService] Token still valid');
        return true;
      }

      console.log('[AuthService] Token expired. Attempting refresh...');
      const user = split.sub;

      const tokenData = {
        accessToken: this.storage.get('token'),
        refreshToken: this.storage.get('refresh_token'),
        userName: user,
      };

      const result: any = await firstValueFrom(
        this.baseHttpService.post(this.constant.refreshToken, tokenData)
      );

      this.storage.set('token', result.auth_token);
      this.storage.set('refresh_token', result.refresh_token);
      console.log('[AuthService] Token refreshed successfully.');
      return true;
    } catch (err) {
      console.error('[AuthService] Failed to validate or refresh token:', err);
      this.router.navigate(['/', 'login']);
      return false;
    }
  }

  removeToken() {
    return this.storage.remove('token');
  }

  async getUserData(token: any): Promise<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const data: any = { accessToken: token };

    return await firstValueFrom(
      // this.http.post('https://qa.intakeportal.healthperform.com/api/Auth/getSiteminderData', data, { headers })
      this.http.post('http://localhost:56430/api/Auth/getSiteminderData', data, { headers })
    );
  }

  // Calls GetOrCreateUser API and stores exp
  async callGetOrCreateUser(payload: { accessToken: string }): Promise<any> {
    console.log(
      '[AuthService] callGetOrCreateUser called with token:',
      payload.accessToken?.slice(0, 40) + '...'
    );

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${payload.accessToken}`,
      authProvider: 'siteminder',
      'X-Custom-Authorization': 'ODP_CWOPA_IDD_AuthProvider',
    });

    // Decode JWT and store expiration
    try {
      const decoded = JSON.parse(atob(payload.accessToken.split('.')[1]));
      if (decoded.exp) {
        this.storage.set('accessTokenExp', decoded.exp.toString());
        console.log('[AuthService] accessTokenExp stored:', decoded.exp);
      }
    } catch (decodeErr) {
      console.error('[AuthService] Error decoding token to extract exp:', decodeErr);
    }

    return await firstValueFrom(
      // this.http.post('https://qa.intakeportal.healthperform.com/api/UserManagement/GetOrCreateUser', payload, { headers })
      this.http.post('http://localhost:56430/api/UserManagement/GetOrCreateUser', payload, { headers })
    );
  }
}
